import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

// Seguros y siniestros comparten estructura; solo cambia el sufijo (Seg / Sin)
function CrearMutaciones(sufijo) {

    const ADD = `
    mutation add($input: InputAddCatTipoSeguimiento!) {
        addCatTipoSeguimiento${sufijo}(input: $input) {
            tipoSeguimientoID
            nombre
            orden
        }
    }`;

    const UPDATE = `
    mutation update($input: InputUpdateCatTipoSeguimiento!) {
        updateCatTipoSeguimiento${sufijo}(input: $input) {
            tipoSeguimientoID
            nombre
            orden
        }
    }`;

    const DELETE = `
    mutation delete($input: InputDeleteCatTipoSeguimiento) {
        deleteCatTipoSeguimiento${sufijo}(input: $input)
    }`;

    const ejecutar = async (query, variables, token, campo) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables,
                url: urlServidor,
                query
            });
            return resultado[campo];
        } catch ({ message }) { throw new Error(message); }
    };

    return {
        add: (variables, token) => ejecutar(ADD, variables, token, `addCatTipoSeguimiento${sufijo}`),
        update: (variables, token) => ejecutar(UPDATE, variables, token, `updateCatTipoSeguimiento${sufijo}`),
        remove: (input, token) => ejecutar(DELETE, { input }, token, `deleteCatTipoSeguimiento${sufijo}`)
    };
}

const mutacionesSeg = CrearMutaciones("Seg");
const mutacionesSin = CrearMutaciones("Sin");

export const addTipoSeguimientoSeg = mutacionesSeg.add;
export const updateTipoSeguimientoSeg = mutacionesSeg.update;
export const deleteTipoSeguimientoSeg = mutacionesSeg.remove;
export const addTipoSeguimientoSin = mutacionesSin.add;
export const updateTipoSeguimientoSin = mutacionesSin.update;
export const deleteTipoSeguimientoSin = mutacionesSin.remove;
